var exports = {
  "i": "x4c3adb35--9bb582--wrapper",
};

module.exports = exports;
